/**
 * Atlas Intelligence > Simulate > Deal model: saved scenarios, kept per person and facility
 * (src/aithora/v3/atlas/scenarios.ts). Every figure in a saved scenario is MODELED: it is the
 * page's own client-side deal model at the moment of saving, with the inputs that made it.
 */
import { route } from './route';
import { AITHORA_PREFIX } from './prefix';

const A = AITHORA_PREFIX;

export interface SavedScenario {
  id: string;
  /** The facility key the scenario belongs to (catalog id, else the deal book id). */
  facilityKey: string;
  name: string;
  irr: string;
  moic: string;
  cov: string;
  eq: string;
  /** The model inputs (sector, loan, structure, lift, edited assumptions). */
  inputs: Record<string, unknown>;
  createdAt: string;
}

export interface SavedScenariosResponse {
  real: true;
  modeled: true;
  scenarios: SavedScenario[];
}

export interface SaveScenarioBody {
  facilityKey: string;
  name: string;
  irr: string;
  moic: string;
  cov: string;
  eq: string;
  inputs: Record<string, unknown>;
}

/** GET /intelligence/scenarios?facility=: this person's saved scenarios for one facility, newest last. */
export const intelScenarios = route<SavedScenariosResponse, { facility: string }>()('GET', `${A}/intelligence/scenarios`, { honest: true });

/** POST /intelligence/scenarios: saves one (keeps the latest 6 per person and facility). */
export const intelSaveScenario = route<{ real: true; scenario: SavedScenario }, void, SaveScenarioBody>()('POST', `${A}/intelligence/scenarios`, { honest: true });
